var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.867,
    height: 11.104,
    viewBox: "0 0 7.867 11.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5774",
    "data-name": "Group 5774",
    transform: "translate(3810.363 3082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    d: "M219.932,89.767l2.678,2.648a.654.654,0,0,1-.924.927l-1.15-1.154c-.193-.193-.347-.129-.347.143v4.809a.653.653,0,1,1-1.306,0V92.33c0-.271-.156-.335-.347-.143l-1.15,1.154a.654.654,0,0,1-.924-.927l2.656-2.646a.58.58,0,0,1,.815,0ZM216.258,100.7a.656.656,0,0,1,0-1.311h6.556a.656.656,0,0,1,0,1.311Z",
    transform: "translate(-4025.965 -3171.6)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.189530c33804fbf3beed3ff5468681f6.svg";
export { ForwardRef as ReactComponent };